import { jsx, jsxs } from "react/jsx-runtime";
import { VoiceThemeProvider } from "../voice/theme/VoiceThemeProvider.js";
import { PromptLoginWidget } from "../voice/components/widgets/PromptLoginWidget.js";
import { ConfirmWidget } from "../voice/components/widgets/ConfirmWidget.js";
import { OrderListWidget } from "../voice/components/widgets/OrderListWidget.js";
import { StoreListWidget } from "../voice/components/widgets/StoreListWidget.js";
import { ReviewInsightsWidget } from "../voice/components/widgets/ReviewInsightsWidget.js";
import { CarouselsWidget } from "../voice/components/widgets/CarouselsWidget.js";
import { ProductCardWidget } from "../voice/components/widgets/ProductCardWidget.js";
import { TicketCardWidget } from "../voice/components/widgets/TicketCardWidget.js";
import { ReturnWidget } from "../voice/components/widgets/ReturnWidget.js";
import { OrderDetailWidget } from "../voice/components/widgets/OrderDetailWidget.js";
import { OrderWidget } from "../voice/components/widgets/OrderWidget.js";
import { CartWidget } from "../voice/components/widgets/CartWidget.js";
import { ComparisonWidget } from "../voice/components/widgets/ComparisonWidget.js";
const TYPE_TO_COMPONENT = {
  "data-widget-comparison": ComparisonWidget,
  "data-widget-cart": CartWidget,
  "data-widget-order": OrderWidget,
  "data-widget-order-detail": OrderDetailWidget,
  "data-widget-return": ReturnWidget,
  "data-widget-ticket": TicketCardWidget,
  "data-widget-product-card": ProductCardWidget,
  "data-widget-carousels": CarouselsWidget,
  "data-widget-review-insights": ReviewInsightsWidget,
  "data-widget-store-list": StoreListWidget,
  "data-widget-order-list": OrderListWidget,
  "data-widget-confirm": ConfirmWidget,
  "data-widget-prompt-login": PromptLoginWidget
};
const SKIPPED_TYPES = /* @__PURE__ */ new Set(["data-widget-tool-running", "data-widget-clear"]);
const READ_ONLY_TYPES = /* @__PURE__ */ new Set(["data-widget-prompt-login"]);
const VoiceWidgetInTextChat = ({
  type,
  data,
  liveLoginCallbacks,
  collapseProductCardFeatures
}) => {
  if (SKIPPED_TYPES.has(type)) return null;
  const Component = TYPE_TO_COMPONENT[type];
  const wrapperStyle = {
    width: "100%",
    overflowX: "auto",
    marginTop: 8,
    marginBottom: 8,
    display: "flex",
    justifyContent: "center"
  };
  if (!Component) {
    return /* @__PURE__ */ jsx("div", { style: wrapperStyle, children: /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          fontSize: 12,
          color: "rgba(0,0,0,0.5)",
          fontStyle: "italic",
          padding: "8px 12px",
          background: "rgba(0,0,0,0.04)",
          borderRadius: 8
        },
        children: [
          "Voice widget · ",
          type
        ]
      }
    ) });
  }
  const extraProps = {};
  if (READ_ONLY_TYPES.has(type)) {
    if (type === "data-widget-prompt-login" && liveLoginCallbacks) {
      extraProps.readOnly = false;
      extraProps.onLoginCompleted = liveLoginCallbacks.onLoginCompleted;
      extraProps.onLoginFailed = liveLoginCallbacks.onLoginFailed;
    } else {
      extraProps.readOnly = true;
    }
  }
  if (type === "data-widget-product-card" && collapseProductCardFeatures) {
    extraProps.collapseKeyFeatures = true;
  }
  return /* @__PURE__ */ jsx("div", { style: wrapperStyle, children: /* @__PURE__ */ jsx(VoiceThemeProvider, { children: /* @__PURE__ */ jsx(Component, { data, ...extraProps }) }) });
};
export {
  READ_ONLY_TYPES,
  SKIPPED_TYPES,
  TYPE_TO_COMPONENT,
  VoiceWidgetInTextChat
};
//# sourceMappingURL=VoiceWidgetInTextChat.js.map
